import { createStyles, Typography, withStyles } from '@material-ui/core';
import React from 'react';
import { TypographyAllProps } from 'globals/types';

const FsBodySmall = withStyles(() =>
  createStyles({
    root: {
      fontSize: 14,
    },
  })
)((props: TypographyAllProps) => (
  <Typography variant="body1" component="p" {...props} />
));

export default FsBodySmall;
